// components/RequireAuth.js
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

export default function RequireAuth({ children }) {
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation(); // ✅ Needed to track where user came from

  useEffect(() => {
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      setIsLoggedIn(!!data.session);
      setLoading(false);
    };
    checkSession();
  }, []);

  if (loading) return <div className="p-4 text-center">Checking login...</div>;

  // ✅ Save the path the user wanted to visit
  return isLoggedIn ? children : (
    <Navigate
      to="/login"
      replace
      state={{ from: location }} // 🔁 pass the original route
    />
  );
}
